import { useDispatch, useSelector } from 'react-redux';
import {
  registerUser,
  userLoadingSelector
} from '../redux/features/user/usersSlice';
import { useRedirectLoggedUserToDashboard } from './useRedirectLoginUserToDashboard';

export const useRegisterUser = () => {
  useRedirectLoggedUserToDashboard();
  const dispatch = useDispatch();
  const isLoading = useSelector(userLoadingSelector);

  const registerUserAction = async ({
    fullName,
    email,
    password,
    username,
    recaptchaToken
  }) => {
    try {
      dispatch(
        registerUser({ fullName, email, password, username, recaptchaToken })
      );
      return { success: true };
    } catch (error) {
      return { success: false, error };
    }
  };

  return { registerUser: registerUserAction, isLoading };
};
